import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { H3 } from '@piconetworks/pkg-heading';
import { P } from '@piconetworks/pkg-text';
import { format } from '@piconetworks/pkg-currency';
import { RemoteJsonText } from '@piconetworks/pkg-remote-markdown';
import '@piconetworks/pkg-module-loader';
import Form from '@piconetworks/pkg-form';
import style from './scss/SelectPass.module.scss.js';

var _excluded = ["fieldContainerProps", "required", "popup", "name", "linkColor", "contrastColor", "isGift", "product", "className", "giftCta", "customFeaturesUrl"];
var SelectPass = function SelectPass(props) {
  var _product$options;
  var fieldContainerProps = props.fieldContainerProps,
    required = props.required;
    props.popup;
    var name = props.name,
    _props$linkColor = props.linkColor,
    linkColor = _props$linkColor === void 0 ? '' : _props$linkColor;
    props.contrastColor;
    var _props$isGift = props.isGift,
    isGift = _props$isGift === void 0 ? false : _props$isGift,
    _props$product = props.product,
    product = _props$product === void 0 ? {} : _props$product,
    className = props.className,
    _props$giftCta = props.giftCta,
    giftCta = _props$giftCta === void 0 ? function () {} : _props$giftCta,
    _props$customFeatures = props.customFeaturesUrl,
    customFeaturesUrl = _props$customFeatures === void 0 ? '' : _props$customFeatures,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var title = product === null || product === void 0 ? void 0 : product.title;
  var formattedOptions = (product === null || product === void 0 ? void 0 : (_product$options = product.options) === null || _product$options === void 0 ? void 0 : _product$options.reduce(function (selections, _ref) {
    var value = _ref.id,
      interval_quantity = _ref.interval_quantity,
      interval = _ref.interval,
      amount = _ref.price,
      currencyCode = _ref.currency;
    var price = format({
      currencyCode: currencyCode,
      amount: amount,
      symbol: true
    });
    var text = isGift ? "Gift the first " + interval : 'Buy Pass';
    selections['pass'] = {
      value: value,
      text: text,
      price: price,
      amount: amount,
      interval_quantity: interval_quantity,
      interval: interval
    };
    return selections;
  }, {})) || [];
  var selectedPlan = formattedOptions === null || formattedOptions === void 0 ? void 0 : formattedOptions.pass;
  var text = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.text;
  var price = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price;
  var value = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.value;
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.container, className)
  }, title && /*#__PURE__*/React.createElement("div", {
    className: style.header
  }, /*#__PURE__*/React.createElement(H3, {
    className: style.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: style.priceContainer
  }, /*#__PURE__*/React.createElement(H3, {
    className: style.price
  }, price), /*#__PURE__*/React.createElement("small", null, "for ", selectedPlan.interval_quantity, " ", selectedPlan.interval))), /*#__PURE__*/React.createElement("div", {
    className: style.dflex
  }, /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", {
    className: style.features
  }, customFeaturesUrl && /*#__PURE__*/React.createElement(RemoteJsonText, {
    url: customFeaturesUrl,
    style: style,
    linkColor: linkColor
  }))), /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", {
    className: style.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: style.buttons
  }, !isGift && /*#__PURE__*/React.createElement(P, {
    className: classNames(style['link-text'], style.gift),
    onClick: function onClick() {
      return giftCta(value);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-icon_gift"
  }), /*#__PURE__*/React.createElement("span", null, "Gift")), /*#__PURE__*/React.createElement(Field, _extends({}, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, {
    name: name,
    render: function render(props) {
      return /*#__PURE__*/React.createElement(Form.Radio, _extends({}, props, {
        className: classNames('btn', style.btn, style.hidden),
        fieldProps: {
          className: classNames('btn', style.btn)
        }
      }));
    },
    text: text,
    value: value,
    type: "radio"
  }, rest))))))));
};

export { SelectPass as default };
//# sourceMappingURL=index.js.map
